import Vue from 'vue'
import './plugins/vee-validate'
import * as controllers from './controllers/'

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector
}

/**
 * Init vue controller.
 */
;[].forEach.call(document.querySelectorAll('[data-controller]'), target => {
  const controller = target.dataset.controller

  if (controllers[controller]) {
    new Vue(controllers[controller]).$mount(target)
  } else {
      console.error(`no vue controller found for ${controller}`)
  }
})

/**
 * Analytics click to call tracking.
 */
;(function () {
  document.addEventListener( 'click', e => {
    if (e.target && e.target.matches('a[href^="tel:"]')) {
      const phone = e.target.href.replace('tel:', '')
      ga('send', 'event', 'Phone Call Tracking', 'Click to Call', phone)
    }
  } )
})()


// WEBPACK FOOTER //
// ./src/index.js